import * as types from '../../actions/actiontypes';

export default function documentDownloadReducer(state={},action) {
	switch (action.type) {
		case types.DOWNLOAD_DOCUMENT: {
            if(action.error==null){
                const link = document.createElement("a");
                link.download = action.docName;
                const blob = new Blob([action.response]);
                link.href = window.URL.createObjectURL(blob);
                link.click();
            }
            return state;
        }
		default:
			return state;
	}
}
